import { fetchExperiencesById, fetchExperienceSearchList } from 'actions/ExperienceActions'
import { take } from 'lib/array/arrayUtils'
import { useEffect, useMemo } from 'react'

import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useExperienceSearchList from './useExperienceSearchList'

interface SearchProps {
  placeId?: string
  placeIdToIgnore?: string
  limit?: number
  sortBy?: Experiences.SortTypes
  excludeIds?: Array<string>
  campaigns?: Array<string>
  randomize?: boolean
  enabled?: boolean
  from?: string
  to?: string
}

function useExperienceSearch(
  searchProps: SearchProps,
  filterProps: Experiences.SearchFilters = {},
): [App.ApiCallState<{ ids: Array<string>, placeId: string | undefined }>, Array<App.ExperienceOffer | undefined>] {
  const {
    placeId,
    placeIdToIgnore,
    limit = 8,
    sortBy,
    excludeIds = [],
    campaigns,
    randomize,
    enabled = true,
    from,
    to,
  } = searchProps
  const {
    categoryCodes,
    priceLte,
    priceGte,
    luxPlusFeatures,
    collections,
  } = filterProps
  const dispatch = useAppDispatch()

  const experienceList = useExperienceSearchList({ categoryCodes, placeId, placeIdToIgnore, sortBy, excludeIds, priceLte, priceGte, campaigns, randomize, enabled, luxPlusFeatures, collections, from, to })
  const experiences = useAppSelector((state) => state.experience.experiences)

  useEffect(() => {
    if (placeId) {
      dispatch(fetchExperienceSearchList(placeId, { categoryCodes, sortBy, priceLte, priceGte, campaigns, collections, from, to }))
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [placeId, categoryCodes, sortBy, campaigns, collections, from, to])

  const experienceItems = useMemo(() => {
    if (experienceList) {
      const ids = take(experienceList.ids, limit)
      return ids.map(id => experiences[id])
    }
    return []
  }, [experienceList, limit, experiences])

  useEffect(() => {
    if (experienceList?.ids) {
      const ids = take(experienceList.ids, limit)
      dispatch(fetchExperiencesById(...ids))
    }
  }, [experienceList?.ids, limit, dispatch])

  return [
    experienceList,
    experienceItems,
  ]
}

export default useExperienceSearch
